export default {"src":"/_next/static/media/FTV.2ee5b3dc.svg","height":18,"width":18};